import { ReactElement } from "react";

interface SpinnerProps
{
    size?: string;
    color?: string;
    caption?: string;
}

// See _spinners.scss partial for color and size options

export const Spinner = (props: SpinnerProps): ReactElement => (
    <div className="spinner-container">
        <span className={`spinner-${props.size || "md"}-${props.color || "blue"}`} />
        {props.caption && <p className="spinner-text">{props.caption}</p>}
    </div>
);

export default Spinner;